var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundSvgDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1506,
    viewBox: "0 0 1440 1506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 118,
    width: 1440,
    height: 1340,
    fill: "#EB996E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234 790.607C234 1271.98 862.298 619.545 1201.5 1455C1973.38 1644.35 2073 1271.98 2073 790.607C2073 309.232 1709.33 0.5 1201.5 0.5C693.674 0.5 234 309.232 234 790.607Z",
    fill: "#EE7A5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.829 982.185C288.27 986.322 266.628 971.388 262.491 948.829C258.354 926.27 276.856 903.974 295.847 900.491C318.406 896.354 340.048 911.288 344.185 933.847C348.322 956.406 333.388 978.048 310.829 982.185Z",
    fill: "#276850"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M437.992 982.185C415.432 986.322 393.791 971.388 389.653 948.829C385.516 926.27 404.019 903.974 423.01 900.491C445.569 896.354 467.211 911.288 471.348 933.847C475.485 956.406 460.551 978.048 437.992 982.185Z",
    fill: "#276850"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSvgDot);
export default __webpack_public_path__ + "static/media/background_svg_dot.be4ef7655a4f1125ba8ce50baa8fa4d5.svg";
export { ForwardRef as ReactComponent };